import React, { useState, useEffect } from 'react';
import './BulkRenderSuccessModal.css';

function BulkRenderSuccessModal({ isOpen, onClose, session, uploadResult }) {
  const [isAcknowledged, setIsAcknowledged] = useState(false);

  // Check if running on localhost to show sync status
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  useEffect(() => {
    if (isOpen && !isAcknowledged) {
      // Modal is opening - sound will be started by parent component
    }
  }, [isOpen, isAcknowledged]);

  if (!isOpen || !session) return null;

  const handleAcknowledge = () => {
    setIsAcknowledged(true);
    onClose(); // This will trigger sound stop in parent
  };

  return (
    <div className="modal-overlay">
      <div className="modal bulk-success-modal">
        <div className="modal-header">
          <h2>🎉 Bulk Render Complete!</h2>
        </div>

        <div className="modal-body">
          <div className="success-content">
            {/* Render Summary */}
            <div className="render-summary">
              <div className="summary-stats">
                <div className="stat-item success">
                  <div className="stat-number">{session.completedCount}</div>
                  <div className="stat-label">Successful</div>
                </div>
                {session.failedCount > 0 && (
                  <div className="stat-item failure">
                    <div className="stat-number">{session.failedCount}</div>
                    <div className="stat-label">Failed</div>
                  </div>
                )}
              </div>
            </div>

            {/* Results by Language */}
            <div className="language-results">
              <h3>Results by Language</h3>
              <div className="results-list">
                {session.queue.map((item, index) => (
                  <div key={index} className={`result-item ${item.status}`}>
                    <div className="result-status">
                      {item.status === 'completed' ? '✅' : '❌'}
                    </div>
                    <div className="result-info">
                      <div className="language-name">{item.displayName}</div>
                      {item.status === 'completed' && item.result && (
                        <div className="result-details">
                          {item.result.total_clips_used} clips • {item.result.final_duration?.toFixed(1)}s
                        </div>
                      )}
                      {item.status === 'failed' && (
                        <div className="error-details">{item.error}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Upload Results */}
            {session.completedCount > 0 && isLocalhost && (
              <div className="upload-results">
                <h3>🚀 Production Server Sync</h3>
                {uploadResult ? (
                  <div className={`upload-status ${uploadResult.success ? 'success' : 'error'}`}>
                    <div className="upload-icon">
                      {uploadResult.success ? '✅' : '❌'}
                    </div>
                    <div className="upload-details">
                      <div className="upload-title">
                        {uploadResult.success ? 'Sync Successful!' : 'Sync Failed'}
                      </div>
                      <div className="upload-message">
                        {uploadResult.message}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="upload-status processing">
                    <div className="upload-icon">⏳</div>
                    <div className="upload-details">
                      <div className="upload-title">Syncing to Production Server...</div>
                      <div className="upload-message">Uploading rendered videos to live server</div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Sound Notification */}
            <div className="sound-notification">
              <div className="notification-icon">🔔</div>
              <div className="notification-text">
                <strong>Notification sound is playing</strong>
                <br />
                Click "Acknowledge" below to stop the sound
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="modal-acknowledge-button"
            onClick={handleAcknowledge}
          >
            🎯 Acknowledge & Stop Sound
          </button>
        </div>
      </div>
    </div>
  );
}

export default BulkRenderSuccessModal;